import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_product_content_block = _resolveComponent("product-content-block")!

  return (_ctx.content.longDescription)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["product-list-content-block", {
      'product-list-content-block--images': !_ctx.hasCarousel && _ctx.content.images,
      'product-list-content-block--carousel': _ctx.hasCarousel && _ctx.content.images && _ctx.content.images.length > 1
    }])
      }, [
        _createVNode(_component_product_content_block, {
          class: "product-list__content-block",
          "show-carousel": _ctx.hasCarousel,
          headline: _ctx.content.displayName,
          text: _ctx.content.longDescription,
          images: _ctx.content.images,
          type: "productList",
          "use-read-more": false
        }, null, 8 /* PROPS */, ["show-carousel", "headline", "text", "images"]),
        _cache[0] || (_cache[0] = _createTextVNode()),
        (_ctx.scaleText)
          ? (_openBlock(), _createBlock(_component_product_content_block, {
              key: 0,
              class: "product-list__content-block",
              text: _ctx.scaleText
            }, null, 8 /* PROPS */, ["text"]))
          : _createCommentVNode("v-if", true)
      ], 2 /* CLASS */))
    : _createCommentVNode("v-if", true)
}